<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-row
          justify="center"
          align="center"
        >
          <v-col
            v-if="isLoading"
            cols="12"
          >
            <v-progress-linear
              indeterminate
              color="primary"
            />
          </v-col>
          <v-col
            v-if="!isLoading"
            cols="12"
            md="6"
          >
            <template v-if="tokenExists">
              <template v-if="tokenExpiredOrUsed">
                <v-alert>
                  This token has already been used, or has expired
                </v-alert>
                <v-btn
                  small
                  text
                  rounded
                  outlined
                  :to="{ name: 'login' }"
                >
                  <v-icon
                    small
                    left
                  >
                    keyboard_backspace
                  </v-icon>
                  Login
                </v-btn>
              </template>
              <template v-else>
                <token-invite-card
                  v-if="token.type === 'invite'"
                  :token="token"
                />
              </template>
            </template>
            <template v-else>
              <v-alert>
                Invalid token
              </v-alert>
              <v-btn
                small
                text
                rounded
                outlined
                :to="{ name: 'login' }"
              >
                <v-icon
                  small
                  left
                >
                  keyboard_backspace
                </v-icon>
                Login
              </v-btn>
            </template>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isEmpty } from 'lodash'
import TokenFinishAuthCard from "../components/Token/TokenFinishAuthCard"
import TokenInviteCard from "../components/Token/TokenInviteCard"

export default {
  components: {
    TokenFinishAuthCard,
    TokenInviteCard
  },
  data() {
    return {
      isLoading: false,
      model: {}
    }
  },
  computed: {
    token() {
      return this.model
    },
    tokenExists() {
      return !isEmpty(this.token)
    },
    tokenExpiredOrUsed() {
      return this.token.isUsed === true
    }
  },
  async mounted() {
    const payload = { id: this.$route.params.id }

    this.isLoading = true
    const token = await this.fetchToken(payload)
      .then(res => res.data)

    if (token) {
      this.model = { ...token }
    }

    this.isLoading = false
  },
  methods: {
    ...mapActions([ 'processToken', 'fetchToken' ]),
  }
}
</script>
